import { DeleteOrganizationAffiliation } from "@/services/fhir/organizationaffiliation/DeleteOrganizationAffiliation";
import { PatchOrganizationAffiliation } from "@/services/fhir/organizationaffiliation/PatchOrganizationAffiliation";
import { Box, Stack, Typography } from "@mui/material";
import { CommonDialog } from "@/components/common/CommonDialog";
import { FormButtonGroup } from "@/components/form/FormButtonGroup";
import { OrganizationAffiliation } from "fhir/r5";
import { toast } from "react-toastify";

interface ConfirmDeleteModalProps {
  open: boolean;
  onClose: () => void;
  affiliation: OrganizationAffiliation;
  handleRefetch: () => void;
}

export const ConfirmDeleteModal = ({
  open,
  onClose,
  affiliation,
  handleRefetch,
}: ConfirmDeleteModalProps) => {
  const handleToggleActive = async (aff: OrganizationAffiliation) => {
    try {
      const currentActive = aff.active === undefined || aff.active === true;
      const hasProperty = aff.hasOwnProperty("active");
      await PatchOrganizationAffiliation({
        id: aff.id || "",
        active: !currentActive,
        hasProperty,
      });
      // Atualiza a lista após a mudança
      handleRefetch();
      toast.success(
        currentActive
          ? "Plano inativado com sucesso"
          : "Plano ativado com sucesso"
      );
    } catch (error) {
      toast.error("Erro ao alterar status do plano");
      console.error("Error toggling affiliation status:", error);
    }
  };
  const onConfirm = async () => {
    await handleToggleActive(affiliation);
    handleRefetch();
    onClose();
  };

  const active =
    affiliation.active === undefined || affiliation.active === true;

  return (
    <CommonDialog
      isOpen={open}
      handleClose={onClose}
      maxWidth="sm"
    >
      <Stack spacing={3} sx={{ minWidth: 400, display: 'flex', justifyContent: 'center' }}>
        <Typography 
          variant="h6" 
          align="center"
          color="primary"
          sx={{ fontWeight: 'bold' }}
        >
          {active ? "Confirmar Inativação" : "Confirmar Ativação"}
        </Typography>
        
        <Typography 
          align="center" 
          variant="body1"
          sx={{ px: 4 }}
        >
          {active
            ? "Tem certeza que deseja inativar este plano?"
            : "Tem certeza que deseja ativar este plano?"}
        </Typography>
        
        <Box sx={{ mt: 2, mb: -2 }}>
          <FormButtonGroup
            onGoBackButtonClick={onClose}
            onNextButtonClick={onConfirm}
            nextButtonText={active ? "Inativar" : "Ativar"}
            goBackButtonText="Cancelar"
            maxWidth
          />
        </Box>
      </Stack>
    </CommonDialog>
  );
};
